import { createSlice } from "@reduxjs/toolkit";
import http from "../../common/cticApi";
import { loginUser } from "../auth/authLoginSlice";

// initial state
export const initialState = {
  loading: false,
  error: null,
  success: false,
  profileDetails: null,
  lawyerProfile:null,
};

// our slice
const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    setLoading: (state) => {
      state.loading = true;
    },
    setError: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
      state.success = false;
    },
    setSuccess: (state) => {
      state.loading = false;
      state.error = false;
      state.success = true;
    },
    setProfile: (state, { payload }) => {
      state.profileDetails = payload;
    },
     setLawyerProfile: (state, { payload }) => {
      state.lawyerProfile = payload;
    },
  },
});
// export the actions
export const { setLoading, setError, setSuccess, setProfile,setLawyerProfile } =
  profileSlice.actions;

export const profileSelector = (state) => state.profile;

// export the default reducer
export default profileSlice.reducer;

// pofile API's
export const GetProfileDetails = (userid, islawyer) => async (dispatch) => {
  try {
    dispatch(setLoading());
    let request = {
      UserID: userid,
      IsLawyer: islawyer,
    };

    let req = { UserID: userid, RequestObject: request };
    const results = await http
      .post("Lawfirm/GetUserProfile", req)
      .then((result) => {
        return result;
      });

    if (results.data.responseCode == 0) {
      dispatch(setProfile(results.data.responseObject));
      dispatch(setSuccess());
    }
  } catch (error) {
    const errorMessage =
      error.response && error.response.data
        ? error.response.data.title
        : error.message;
    dispatch(setError(errorMessage));
  }
};

export const GetLawyerProfile = (userid) => async (dispatch) => {
  try {
    dispatch(setLoading());
    let request = {
      UserID: userid,
      IsLawyer: true,
    };

    let req = { UserID: userid, RequestObject: request };
    const results = await http
      .post("Lawfirm/GetLawyerProfile", req)
      .then((result) => {
        return result;
      });

    if (results.data.responseCode == 0) {
      dispatch(setLawyerProfile(results.data.responseObject));
      dispatch(setSuccess());
    }
  } catch (error) {
    const errorMessage =
      error.response && error.response.data
        ? error.response.data.title
        : error.message;
    dispatch(setError(errorMessage));
  }
};

export const UpdateProfile =
  (request, { toast }) =>
  async (dispatch) => {
    try {
      dispatch(setLoading());
      let req = { UserID: request.UserID, RequestObject: request };
      const results = await http
        .post("Lawfirm/UpdateUser", req)
        .then((result) => {
          return result;
        });

      if (results.data.responseCode == 0) {
        toast("User updated successfully!", { type: "success" });
        dispatch(setSuccess());
        dispatch(GetProfileDetails(request.UserID, request.IsLawyer));
      }
    } catch (error) {
      const errorMessage =
        error.response && error.response.data
          ? error.response.data.title
          : error.message;
      dispatch(setError(errorMessage));
    }
  };

// notifications API's
export const GetNotificationsDetails = (userid, firmid) => async (dispatch) => {
  //this should get notiification type, reciepients details, and notification history
  try {
    dispatch(setLoading());
    let request = {
      UserID: userid,
      FirmID: firmid,
    };

    let req = { UserID: userid, RequestObject: request };
    const results = await http
      .post("Lawfirm/GetNotificationsDetails", req)
      .then((result) => {
        return result;
      });

    if (results.data.responseCode == 0) {
      dispatch(setSuccess());
    }
  } catch (error) {
    const errorMessage =
      error.response && error.response.data
        ? error.response.data.title
        : error.message;
    dispatch(setError(errorMessage));
  }
};

export const SaveNotificationsDetails =
  (notifications, userid, firmid) => async (dispatch) => {
    try {
      dispatch(setLoading());
      let request = {
        UserID: userid,
        FirmID: firmid,
        AccountBalance:notifications.AccountBalance,
        OutstandingInvoice:notifications.OutstandingInvoice,
        PaidInvoice:notifications.PaidInvoices
      };

      let req = { UserID: userid, RequestObject: request };
      const results = await http
        .post("Lawfirm/SaveNotificationsDetails", req)
        .then((result) => {
          return result;
        });

      if (results.data.responseCode == 0) {
        dispatch(setSuccess());
      }
    } catch (error) {
      const errorMessage =
        error.response && error.response.data
          ? error.response.data.title
          : error.message;
      dispatch(setError(errorMessage));
    }
  };
